import { createApp } from 'vue'
import App from './App.vue'
import './main.css'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import { Toast } from 'vant'
import { showLoadingToast } from 'vant'
import FloatingPanel from 'vant'
import Popup from 'vant'
import Calendar from 'vant'
import DatePicker from 'vant'
import { ImagePreview } from 'vant'
import { Icon } from 'vant'
import { NavBar } from 'vant';
import { Slider } from 'vant';
import { TreeSelect } from 'vant';
import { Notify } from 'vant';
import { Uploader } from 'vant';
import { Field } from 'vant';
import { CellGroup } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { Cascader } from 'vant';
import { Step, Steps } from 'vant';
import "vue-data-ui/style.css"
import { VueUiRadar } from "vue-data-ui"
import { createPinia } from "pinia"
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { RecycleScroller } from 'vue-virtual-scroller'
const app = createApp(App)
const pinia = createPinia()

app.use(store)
    .use(router)
    .use(pinia)
    .use(Vant)
    .use(Toast)
    .use(FloatingPanel)
    .use(Popup)
    .use(Calendar)
    .use(DatePicker)
    .use(ImagePreview)
    .use(Icon)
    .use(NavBar)
    .use(Slider)
    .use(TreeSelect)
    .use(Notify)
    .use(Uploader)
    .use(Field)
    .use(CellGroup)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Cascader)
    .use(Step )
    .use(Steps);

app.component("VueUiRadar", VueUiRadar)
//虚拟滚动
app.component('RecycleScroller', RecycleScroller)
app.mount('#app')
/*if(process.env.NODE_ENV === 'production') {
    document.addEventListener('deviceready', function () {
        app.mount('#app')
    }, false)
} else {
    app.mount('#app')
}*/
// 禁止双击缩放
let lastTouchEnd = 0;
document.addEventListener('touchend', function (event) {
    const now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
        event.preventDefault();
    }
    lastTouchEnd = now;
}, false);

// 禁止双指缩放
document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
        event.preventDefault();
    }
});
